.noButtonPadding button {
	padding: 0;
}
